import { type ComputedRef, computed } from 'vue';
import useUserStore from '../user.store';
import { storeToRefs } from 'pinia';
interface ReturnUseAvailableCredit {
  availableCreditContent: ComputedRef<string>;
  isCreditLimit: ComputedRef<boolean>;
  overdueIsMoreZero: ComputedRef<boolean>;
}

export const useAvailableCredit = (): ReturnUseAvailableCredit => {
  const { user } = storeToRefs(useUserStore());

  const isCreditLimit = computed(() => user.value?.credit?.creditLimit != null);

  const overdueIsMoreZero = computed(() => {
    const overdue = user.value?.credit?.overdue;

    if (overdue === undefined) return false;

    return parseFloat(String(overdue.amount)) > 0;
  });

  const creditLimitIsMoreZero = computed(() => {
    const creditLimit = user.value?.credit?.creditLimit;

    if (creditLimit === undefined) return false;

    return parseFloat(String(creditLimit.amount)) > 0;
  });

  const availableCreditContent = computed(() => {
    if (overdueIsMoreZero.value) {
      return String(user.value?.credit?.overdue) ?? '0.00';
    } else if (creditLimitIsMoreZero.value) {
      return String(user.value?.credit?.creditLimit) ?? '0.00';
    }

    return '0.00';
  });

  return {
    availableCreditContent,
    isCreditLimit,
    overdueIsMoreZero,
  };
};
